import BaseModule from '@core/modules/base-module/base-module';

const sitemap = new BaseModule();
sitemap.name = 'sitemap';
sitemap.init();
